import { render, staticRenderFns } from "./LoanNavHelpCenter.vue?vue&type=template&id=272c6271&scoped=true&"
import script from "./LoanNavHelpCenter.vue?vue&type=script&lang=ts&"
export * from "./LoanNavHelpCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c6271",
  null
  
)

export default component.exports